var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcnPerfil(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.51436 3.64648H3.51172C2.40715 3.64648 1.51172 4.54192 1.51172 5.64648V17.6628C1.51172 18.7673 2.40715 19.6628 3.51172 19.6628H5.51436M11.5183 3.64648H13.521C14.6255 3.64648 15.521 4.54191 15.521 5.64648V7.65056",
    stroke: "#02BCFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4187 18.9966L9.23034 19.4344L9.66802 17.2452C9.70673 17.0516 9.80187 16.8738 9.94144 16.7342L14.0182 12.6558L16.0195 10.6538L18.0077 12.6427L16.0064 14.6447L11.9296 18.723C11.79 18.8627 11.6123 18.9578 11.4187 18.9966Z",
    stroke: "#02BCFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.51562 3.64453C5.51562 2.53996 6.41106 1.64453 7.51563 1.64453H9.51959C10.6242 1.64453 11.5196 2.53996 11.5196 3.64453V5.6486H5.51562V3.64453Z",
    stroke: "#02BCFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnPerfil);
export default __webpack_public_path__ + "static/media/icn_perfil.58bc9769e682decda59cb7cc880289ac.svg";
export { ForwardRef as ReactComponent };